export interface AppShortcut {
  title: string;
  description: string;
  url: string;
  gradient: string;
  imageName: string;
  hoverGradient: string;
}

const isPrd = process.env.NODE_ENV === 'production';

export const apps: AppShortcut[] = [
  {
    title: 'CRM',
    description: 'Customer Relationship Management',
    url: isPrd ? 'https://crm-v2.mindx.edu.vn/' : 'https://crm-v2-dev.mindx.edu.vn/',
    gradient: 'from-green-400 to-green-600',
    hoverGradient: 'from-green-500 to-green-700',
    imageName: 'crm-logo-1.png',
  },
  {
    title: 'LMS',
    description: 'Learning Management System',
    url: isPrd ? 'https://lms.mindx.edu.vn' : 'https://lms-dev.mindx.edu.vn',
    gradient: 'from-orange-400 to-orange-600',
    hoverGradient: 'from-orange-500 to-orange-700',
    imageName: 'lms-logo-1.png',
  },
  {
    title: 'TMS',
    description: 'Timesheet Management System',
    url: isPrd ? 'https://tms.mindx.edu.vn' : 'https://tms-dev.mindx.edu.vn',
    gradient: 'from-purple-400 to-purple-600',
    hoverGradient: 'from-purple-500 to-purple-700',
    imageName: 'tms-logo.png',
  },
  {
    title: 'Elearning',
    description: 'Online Learning Platform',
    url: isPrd ? 'https://denise.mindx.edu.vn' : 'https://denise-dev.mindx.edu.vn',
    gradient: 'from-pink-400 to-pink-600',
    hoverGradient: 'from-pink-500 to-pink-700',
    imageName: 'denise-logo.png',
  },
  {
    title: 'IT Helpdesk',
    description: 'IT Helpdesk',
    url: 'https://techteam-mindx.freshdesk.com',
    gradient: 'from-blue-400 to-blue-600',
    hoverGradient: 'from-blue-500 to-blue-700',
    imageName: 'it-helpdesk-logo.png',
  },
];
